enum LoadType {
    Spot = 0,
    Dedicated = 1,
    SemiDedicated = 2,
    OtherModes = 3,
    Loyal = 4,
    Hub = 5,
    DraftBeer = 6,
}

export default LoadType;
